/* Meena cart drawer (Oct 2026)
 * Opens a custom cart drawer instead of the cart page, and keeps GoKwik for checkout.
 * Markup comes from sections/mf-cart-drawer.liquid (re-rendered through the Section Rendering API).
 */
(function () {
  'use strict';
  if (window.MFCart) return;

  var drawer = document.getElementById('mf-cart');
  if (!drawer) return;

  var SECTION = 'mf-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_PATH_RE = /^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?cart\/?$/i;
  var IS_CART_PAGE = CART_PATH_RE.test(location.pathname);
  var nativeFetch = window.fetch.bind(window);
  var panel = drawer.querySelector('.mfc__panel');
  var toastEl = document.querySelector('[data-mf-toast]');
  var state = { codes: [], couponOpen: false, couponMsg: null, inlineErr: null, lastFocus: null };
  var refreshTimer = null, toastTimer = null, refreshing = null;

  function body() { return drawer.querySelector('[data-mf-cart-body]'); }

  /* ---------------- helpers ---------------- */
  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, opts.headers || {});
    return nativeFetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var e = new Error(j.description || j.message || 'Something went wrong. Please try again.');
          e.status = r.status;
          throw e;
        }
        return j;
      });
    });
  }
  function postJSON(path, data) {
    return jsonFetch(ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
  }
  function setBusy(on) { drawer.classList.toggle('is-busy', !!on); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function toast(msg) {
    if (isOpen()) { state.inlineErr = msg; showInlineErr(); return; }
    if (!toastEl) { alertFallback(msg); return; }
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 4500);
  }
  function alertFallback(msg) { try { console.warn('[mf-cart]', msg); } catch (e) {} }
  function showInlineErr() {
    var scroll = drawer.querySelector('.mfc__scroll');
    var old = drawer.querySelector('.mfc-inline-err');
    if (old) old.remove();
    if (!state.inlineErr || !scroll) return;
    var p = document.createElement('p');
    p.className = 'mfc-inline-err';
    p.textContent = state.inlineErr;
    scroll.insertBefore(p, scroll.firstChild);
    scroll.scrollTop = 0;
    state.inlineErr = null;
  }

  function updateCounts(count) {
    if (count == null || isNaN(count)) return;
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
      if (el.closest('#mf-cart')) return;
      el.textContent = count;
      el.classList.toggle('hidden', Number(count) === 0 && el.classList.contains('cart-count--hide-empty'));
    });
  }

  /* ---------------- floating chat bubbles ---------------- */
  // Chat apps (WhatsApp etc.) float above everything; hide them while the cart is open.
  var CHAT_SEL = 'a[href*="wa.me"], a[href*="api.whatsapp"], a[href*="whatsapp.com"], [class*="whatsapp" i], [id*="whatsapp" i], ' +
    '[aria-label*="whatsapp" i], [title*="whatsapp" i], img[src*="whatsapp" i], img[alt*="whatsapp" i], iframe[src*="whatsapp" i], iframe[title*="whatsapp" i]';
  var hiddenFloats = [];
  function fixedAncestor(el) {
    var n = el, hops = 0;
    while (n && n !== document.body && hops < 8) {
      var cs = window.getComputedStyle(n);
      if (cs.position === 'fixed') return n;
      n = n.parentElement; hops++;
    }
    return null;
  }
  function hideFloats() {
    var found = [];
    try {
      document.querySelectorAll(CHAT_SEL).forEach(function (el) {
        if (el.closest('#mf-cart')) return;
        var f = fixedAncestor(el);
        if (f && f !== document.body && !f.contains(drawer) && found.indexOf(f) === -1) found.push(f);
      });
      // widgets rendered inside a shadow root
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (el === drawer || !el.shadowRoot) return;
        if (/whatsapp|wa\.me/i.test(el.shadowRoot.innerHTML || '') && found.indexOf(el) === -1) found.push(el);
      });
    } catch (e) {}
    found.forEach(function (el) { el.classList.add('mf-float-hidden'); });
    hiddenFloats = found;
  }
  function showFloats() {
    hiddenFloats.forEach(function (el) { el.classList.remove('mf-float-hidden'); });
    hiddenFloats = [];
  }

  /* ---------------- open / close ---------------- */
  function isOpen() { return drawer.classList.contains('is-open'); }
  function open() {
    if (isOpen()) return;
    state.lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('mf-cart-lock');
    hideFloats();
    // next frame so the slide-in transition runs
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        try { panel.focus({ preventScroll: true }); } catch (e) {}
        if (state.pendingConfetti) { state.pendingConfetti = false; setTimeout(confetti, 320); }
      });
    });
  }
  function close() {
    if (!isOpen()) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('mf-cart-lock');
    showFloats();
    setTimeout(function () { if (!isOpen()) drawer.hidden = true; }, 340);
    if (state.lastFocus && state.lastFocus.focus) { try { state.lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------------- render ---------------- */
  var queued = null;
  function refresh() {
    // If a refresh is already running, run one more after it so we never show a stale cart
    if (refreshing) {
      if (!queued) queued = refreshing.then(function () { queued = null; return refresh(); });
      return queued;
    }
    var bust = '&_=' + Date.now();
    refreshing = Promise.all([
      nativeFetch(ROOT + '?sections=' + SECTION + bust, { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      jsonFetch(ROOT + 'cart.js?_=' + Date.now()).catch(function () { return null; })
    ]).then(function (res) {
      var html = res[0] && res[0][SECTION];
      var cart = res[1];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nb = doc.querySelector('[data-mf-cart-body]');
        var cur = body();
        if (nb && cur) {
          var scroll = cur.querySelector('.mfc__scroll');
          var top = scroll ? scroll.scrollTop : 0;
          cur.innerHTML = nb.innerHTML;
          cur.setAttribute('data-count', nb.getAttribute('data-count'));
          var ns = cur.querySelector('.mfc__scroll');
          if (ns) ns.scrollTop = top;
        }
      }
      if (cart) {
        state.codes = (cart.discount_codes || []).map(function (d) { return { code: d.code, ok: d.applicable !== false }; });
        updateCounts(cart.item_count);
        if (window.cart && typeof window.cart === 'object') window.cart = cart; // keep GoKwik's copy fresh
      } else {
        updateCounts(Number(body().getAttribute('data-count')));
      }
      afterRender();
    }).catch(function () {
      // fall back: keep what we have
    }).then(function () { refreshing = null; });
    return refreshing;
  }

  function fmtDay(d) { return d.getDate() + ' ' + d.toLocaleDateString('en-IN', { month: 'short' }); }
  function eta() {
    var min = Number(drawer.getAttribute('data-eta-min') || 4);
    var max = Number(drawer.getAttribute('data-eta-max') || 7);
    var a = new Date(), b = new Date();
    a.setDate(a.getDate() + min);
    b.setDate(b.getDate() + max);
    if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + fmtDay(b);
    return fmtDay(a) + ' – ' + fmtDay(b);
  }

  function afterRender() {
    var e = drawer.querySelector('[data-mf-eta]');
    if (e) e.textContent = eta();

    // coupon box state
    var toggle = drawer.querySelector('[data-mf-coupon-toggle]');
    var box = drawer.querySelector('[data-mf-coupon-box]');
    if (toggle && box) {
      var openBox = state.couponOpen;
      box.hidden = !openBox;
      toggle.setAttribute('aria-expanded', openBox ? 'true' : 'false');
    }
    var inp = drawer.querySelector('[data-mf-coupon] input');
    var applyBtn = drawer.querySelector('[data-mf-coupon] button');
    if (inp && applyBtn) applyBtn.disabled = !inp.value.trim();

    // Estimated Total breakdown
    var bt = drawer.querySelector('[data-mf-break-toggle]');
    var bp = drawer.querySelector('[data-mf-break]');
    if (bt && bp) {
      bp.hidden = !state.breakOpen;
      bt.setAttribute('aria-expanded', state.breakOpen ? 'true' : 'false');
    }

    // Celebrate when an offer newly applies
    var applied = Array.prototype.map.call(drawer.querySelectorAll('[data-mf-offer-applied]'), function (el) { return el.getAttribute('data-mf-offer-applied'); });
    if (state.applied) {
      var fresh = applied.filter(function (a) { return state.applied.indexOf(a) === -1; });
      if (fresh.length) { if (isOpen()) confetti(); else state.pendingConfetti = true; }
    }
    state.applied = applied;

    var msg = drawer.querySelector('[data-mf-coupon-msg]');
    if (msg) {
      if (state.couponMsg) {
        msg.textContent = state.couponMsg.text;
        msg.className = 'mfc-coupon__msg ' + (state.couponMsg.ok ? 'is-ok' : 'is-err');
        msg.hidden = false;
      } else {
        msg.hidden = true;
      }
    }
    showInlineErr();
  }

  // Short confetti burst over the drawer (skipped for people who prefer reduced motion)
  function confetti() {
    var cv = drawer.querySelector('[data-mf-confetti]');
    if (!cv || !cv.getContext) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = panel.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = r.width * dpr; cv.height = r.height * dpr;
    cv.style.width = r.width + 'px'; cv.style.height = r.height + 'px';
    var ctx = cv.getContext('2d');
    ctx.scale(dpr, dpr);
    var colors = ['#c3a05c', '#e8cf8f', '#1c9a83', '#f2a7b5', '#7fb7e8', '#f4d35e', '#b08d4c'];
    var parts = [];
    for (var i = 0; i < 90; i++) {
      parts.push({
        x: r.width * (0.15 + Math.random() * 0.7), y: r.height * 0.35 + Math.random() * 40,
        vx: (Math.random() - 0.5) * 7, vy: -6 - Math.random() * 7,
        w: 5 + Math.random() * 5, h: 3 + Math.random() * 4, rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.3,
        c: colors[i % colors.length]
      });
    }
    var start = performance.now();
    (function frame(now) {
      var t = now - start;
      ctx.clearRect(0, 0, r.width, r.height);
      parts.forEach(function (p) {
        p.vy += 0.22; p.vx *= 0.99; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot);
        ctx.globalAlpha = Math.max(0, 1 - t / 1800);
        ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (t < 1800) requestAnimationFrame(frame); else ctx.clearRect(0, 0, r.width, r.height);
    })(start);
  }

  // Swap a line to another variant, keeping quantity and properties
  function changeVariant(sel) {
    var key = sel.getAttribute('data-key');
    var qty = Number(sel.getAttribute('data-qty')) || 1;
    var id = Number(sel.value);
    setBusy(true);
    jsonFetch(ROOT + 'cart.js').then(function (cart) {
      var line = (cart.items || []).filter(function (i) { return i.key === key; })[0];
      var props = (line && line.properties) || {};
      return postJSON('cart/change.js', { id: key, quantity: 0 }).then(function () {
        return postJSON('cart/add.js', { items: [{ id: id, quantity: qty, properties: props }] });
      });
    }).catch(function (err) { state.inlineErr = err.message; })
      .then(refresh)
      .then(function () { setBusy(false); });
  }

  /* ---------------- cart actions ---------------- */
  function addFormData(fd) {
    return jsonFetch(ROOT + 'cart/add.js', { method: 'POST', body: fd });
  }

  function change(key, qty) {
    setBusy(true);
    return postJSON('cart/change.js', { id: key, quantity: qty })
      .catch(function (err) { state.inlineErr = err.message; })
      .then(refresh)
      .then(function () { setBusy(false); });
  }

  function quickAdd(btn) {
    var id = Number(btn.getAttribute('data-mf-quick'));
    if (!id) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    setBusy(true);
    postJSON('cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .catch(function (err) { state.inlineErr = err.message; })
      .then(refresh)
      .then(function () { setBusy(false); });
  }

  function setCodes(codes) {
    return postJSON('cart/update.js', { discount: codes.join(',') });
  }

  function applyCoupon(code) {
    code = (code || '').trim();
    if (!code) { state.couponMsg = { ok: false, text: 'Please enter a coupon code.' }; afterRender(); return; }
    var lower = code.toLowerCase();
    var keep = state.codes.filter(function (c) { return c.ok && c.code.toLowerCase() !== lower; }).map(function (c) { return c.code; });
    setBusy(true);
    setCodes(keep.concat([code])).then(function (cart) {
      if (!cart || !cart.discount_codes) {
        // Older storefronts without the Ajax discount parameter: use the discount URL instead
        return nativeFetch(ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'cart.js'), { credentials: 'same-origin' })
          .then(function () { return jsonFetch(ROOT + 'cart.js'); });
      }
      return cart;
    }).then(function (cart) {
      var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === lower; })[0];
      if (hit && hit.applicable !== false) {
        // the "CODE applied · Saved ₹X" strip shows it, so close the box
        state.couponMsg = null;
        state.couponOpen = false;
      } else {
        state.couponMsg = { ok: false, text: 'Coupon “' + code.toUpperCase() + '” can’t be used with this cart.' };
        // drop the invalid code so it doesn't sit in the cart
        if (hit) return setCodes(keep);
      }
    }).catch(function (err) {
      state.couponMsg = { ok: false, text: err.message };
    }).then(refresh).then(function () { setBusy(false); });
  }

  function removeCoupon(code) {
    var lower = code.toLowerCase();
    var keep = state.codes.filter(function (c) { return c.ok && c.code.toLowerCase() !== lower; }).map(function (c) { return c.code; });
    state.couponMsg = null;
    setBusy(true);
    setCodes(keep).catch(function (err) { state.inlineErr = err.message; }).then(refresh).then(function () { setBusy(false); });
  }

  function checkout(btn) {
    btn.classList.add('is-loading');
    var tries = 0;
    (function go() {
      if (typeof window.onCheckoutClick === 'function') {
        try {
          window.onCheckoutClick(btn);
          setTimeout(function () { btn.classList.remove('is-loading'); }, 2500);
          return;
        } catch (e) { /* fall through to Shopify checkout */ }
      } else if (tries++ < 20) {
        setTimeout(go, 200); // GoKwik script still loading
        return;
      }
      window.location.href = ROOT + 'checkout';
    })();
  }

  /* ---------------- add-to-cart interception ---------------- */
  function isAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add/.test(action) && !form.closest('#mf-cart');
  }
  function isAddButton(btn) {
    if (!btn || btn.disabled) return false;
    if (btn.id === 'gokwik-buy-now' || btn.closest('.gokwik-checkout, .shopify-payment-button, .btn-checkout-dynamic')) return false;
    var type = (btn.getAttribute('type') || 'submit').toLowerCase();
    return type === 'submit' || btn.getAttribute('name') === 'add';
  }

  function submitAddForm(form, btn) {
    var fd = new FormData(form);
    if (!fd.get('id')) {
      var idEl = form.querySelector('[name="id"]');
      if (idEl && idEl.value) fd.set('id', idEl.value);
    }
    if (!fd.get('id')) { toast('Please choose an option first.'); return; }
    if (btn) { btn.classList.add('mf-adding'); btn.setAttribute('aria-busy', 'true'); }
    addFormData(fd).then(function () {
      if (IS_CART_PAGE) { window.location.reload(); return; }
      return refresh().then(open);
    }).catch(function (err) {
      toast(err.message);
    }).then(function () {
      if (btn) { btn.classList.remove('mf-adding'); btn.removeAttribute('aria-busy'); }
    });
  }

  function isCartLink(a) {
    if (!a || !a.href || a.target === '_blank') return false;
    if (a.id === 'cart-icon-bubble') return true;
    try {
      var u = new URL(a.href, location.href);
      return u.origin === location.origin && CART_PATH_RE.test(u.pathname) && !u.search;
    } catch (e) { return false; }
  }

  // Capture phase on window runs before the theme's and apps' own handlers.
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('#mf-cart')) return; // drawer handles its own clicks below

    var a = t.closest('a[href]');
    if (a && !IS_CART_PAGE && isCartLink(a) && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      refresh();
      return;
    }

    var btn = t.closest('button, input[type="submit"]');
    if (btn) {
      var form = btn.form || btn.closest('form');
      if (isAddForm(form) && isAddButton(btn)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (btn.classList.contains('mf-adding')) return;
        submitAddForm(form, btn);
      }
    }
  }, true);

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = e.submitter || form.querySelector('[type="submit"], [name="add"]');
    if (btn && btn.classList.contains('mf-adding')) return;
    submitAddForm(form, btn);
  }, true);

  /* ---------------- drawer interactions ---------------- */
  drawer.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mf-close]')) { e.preventDefault(); close(); return; }

    var q = t.closest('[data-mf-qty]');
    if (q) { e.preventDefault(); change(q.getAttribute('data-key'), Number(q.getAttribute('data-mf-qty'))); return; }

    var qa = t.closest('[data-mf-quick]');
    if (qa) { e.preventDefault(); quickAdd(qa); return; }

    var tg = t.closest('[data-mf-coupon-toggle]');
    if (tg) {
      state.couponOpen = !state.couponOpen;
      afterRender();
      if (state.couponOpen) { var inp = drawer.querySelector('[data-mf-coupon] input'); if (inp) inp.focus({ preventScroll: true }); }
      return;
    }

    var bk = t.closest('[data-mf-break-toggle]');
    if (bk) { state.breakOpen = !state.breakOpen; afterRender(); return; }

    var rc = t.closest('[data-mf-rmcode]');
    if (rc) { e.preventDefault(); removeCoupon(rc.getAttribute('data-mf-rmcode')); return; }

    var co = t.closest('[data-mf-checkout]');
    if (co) { e.preventDefault(); checkout(co); return; }
  });

  drawer.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-mf-variant]');
    if (sel) changeVariant(sel);
  });

  drawer.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('[data-mf-coupon]');
    if (!f) return;
    var b = f.querySelector('button');
    if (b) b.disabled = !e.target.value.trim();
    if (state.couponMsg) { state.couponMsg = null; afterRender(); }
  });

  drawer.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-mf-coupon]');
    if (!f) return;
    e.preventDefault();
    applyCoupon(f.querySelector('input').value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  /* ---------------- keep in sync with other scripts ---------------- */
  // Bundle builders, quick shop and apps call the cart API directly. Refresh the drawer after
  // their changes, and open it after an add (unless we are on the cart page).
  function scheduleRefresh(wasAdd) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refresh().then(function () { if (wasAdd && !IS_CART_PAGE) open(); });
    }, 120);
  }
  var CART_API_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    var m = CART_API_RE.exec(url);
    if (m) {
      p.then(function (r) { if (r && r.ok) scheduleRefresh(m[1] === 'add'); }).catch(function () {});
    }
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this._mfUrl = url; return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this, m = CART_API_RE.exec(String(x._mfUrl || ''));
    if (m) x.addEventListener('load', function () { if (x.status < 400) scheduleRefresh(m[1] === 'add'); });
    return xSend.apply(this, arguments);
  };

  // Back/forward cache can show a stale cart
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  afterRender();
  // initial state for coupon chips
  jsonFetch(ROOT + 'cart.js').then(function (cart) {
    state.codes = (cart.discount_codes || []).map(function (d) { return { code: d.code, ok: d.applicable !== false }; });
    updateCounts(cart.item_count);
    afterRender();
  }).catch(function () {});

  window.MFCart = { open: open, close: close, refresh: refresh };
  document.dispatchEvent(new CustomEvent('mf-cart:ready'));
})();
